module.exports = __webpack_public_path__ + "static/1-2c31ed6cf9a8d15848d6e02adbb96eb8.svg";